import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=4515b5be"
import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports